<div class="fx-affiliate-create">
  <div class="row">
    <div class="col">
      <fx-page-header title="Create MT5 Account"></fx-page-header>
    </div>
  </div>
  <div class="card bg-dark-lighter text-white mb-3">
    <div class="card-body">
      <div class="row fs-16">
        <div class="col">
          <span class="text-white">{{ 'Create MT5 Account' }}</span>
        </div>
      </div>
      <form class="form" #formAcc="ngForm" autocomplete="off" (ngSubmit)="onCreateUser()">
        <div class="row mt-4">
          <div class="col-md-6 col-xs-12">
            <mat-form-field appearance="fill" floatLabel="auto">
              <mat-label>User email</mat-label>
              <input
                matInput
                type="email"
                placeholder=""
                name="useremail"
                [(ngModel)]="account.userEmail"
                #useremail="ngModel"
                required
                [disabled]="!permission.allowCreating"
              />
            </mat-form-field>
          </div>
        </div>
        <div class="row mt-3">
          <div class="col-md-6 col-xs-12">
            <mat-form-field appearance="fill" floatLabel="auto">
              <mat-label>IB email</mat-label>
              <input
                matInput
                type="email"
                placeholder=""
                (focusout)="getListTraderCampaign()"
                name="ibemail"
                [(ngModel)]="account.ibEmail"
                #ibemail="ngModel"
                required
                [disabled]="!permission.allowCreating"
              />
            </mat-form-field>
          </div>
        </div>

        <div class="row mt-3">
          <div class="col-md-6 col-xs-12">
            <mat-form-field appearance="fill" floatLabel="auto">
              <mat-label>Trader Campaign</mat-label>
              <mat-select name="campaign" [(ngModel)]="account.campaign" required (selectionChange)="changeReferLink()"
                  disabled="{{!permission.allowCreating}}">
                <mat-option *ngFor="let item of listCampaign" [value]="item.id">
                  <span labelGroup="{{item.description}}"></span>
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>
        <ng-container *ngIf="account.campaign">
          <div class="row mt-3">
            <div class="col-md-6 col-xs-12">
              <mat-form-field appearance="fill" floatLabel="auto">
                <mat-label>Group config</mat-label>
                <mat-select name="groupConfig" [(ngModel)]="account.groupConfig" required>
                  <mat-option *ngFor="let item of groupSetting" [value]="item.id">
                    <span labelGroup="{{ item.name }}"></span>
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
          </div>
        </ng-container>
        <div class="row mt-2" *ngIf="permission.allowCreating">
          <div class="col-md-6 col-xs-12">
            <button class="btn btn-main w-100 fs-16" type="submit">Create</button>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>
